import { render, staticRenderFns } from "./SyncRespondents.vue?vue&type=template&id=a7620e28"
import script from "./SyncRespondents.vue?vue&type=script&lang=js"
export * from "./SyncRespondents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports